'use strict';

var cov_2azlcqa2zm = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\modules\\date.js',
      hash = '68fbe8ca2ba2891b5c9cf21e92534a5f49d10fa7',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\modules\\date.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 129,
          column: 4
        }
      },
      '1': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 128,
          column: 4
        }
      },
      '2': {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 7,
          column: 7
        }
      },
      '3': {
        start: {
          line: 6,
          column: 8
        },
        end: {
          line: 6,
          column: 20
        }
      },
      '4': {
        start: {
          line: 8,
          column: 20
        },
        end: {
          line: 8,
          column: 35
        }
      },
      '5': {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 9,
          column: 35
        }
      },
      '6': {
        start: {
          line: 10,
          column: 15
        },
        end: {
          line: 10,
          column: 30
        }
      },
      '7': {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 13,
          column: 7
        }
      },
      '8': {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 22
        }
      },
      '9': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 16,
          column: 7
        }
      },
      '10': {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 22
        }
      },
      '11': {
        start: {
          line: 17,
          column: 19
        },
        end: {
          line: 17,
          column: 38
        }
      },
      '12': {
        start: {
          line: 18,
          column: 19
        },
        end: {
          line: 18,
          column: 25
        }
      },
      '13': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 44
        }
      },
      '14': {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 44
        }
      },
      '15': {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 40
        }
      },
      '16': {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 40
        }
      },
      '17': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 40
        }
      },
      '18': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 40
        }
      },
      '19': {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 20
        }
      },
      '20': {
        start: {
          line: 28,
          column: 21
        },
        end: {
          line: 28,
          column: 23
        }
      },
      '21': {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 53
        }
      },
      '22': {
        start: {
          line: 30,
          column: 18
        },
        end: {
          line: 30,
          column: 51
        }
      },
      '23': {
        start: {
          line: 31,
          column: 21
        },
        end: {
          line: 31,
          column: 32
        }
      },
      '24': {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 37,
          column: 7
        }
      },
      '25': {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 36,
          column: 11
        }
      },
      '26': {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 20
        }
      },
      '27': {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 46,
          column: 7
        }
      },
      '28': {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 44,
          column: 9
        }
      },
      '29': {
        start: {
          line: 43,
          column: 10
        },
        end: {
          line: 43,
          column: 26
        }
      },
      '30': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 94
        }
      },
      '31': {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 59
        }
      },
      '32': {
        start: {
          line: 50,
          column: 19
        },
        end: {
          line: 50,
          column: 21
        }
      },
      '33': {
        start: {
          line: 51,
          column: 23
        },
        end: {
          line: 51,
          column: 25
        }
      },
      '34': {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 82,
          column: 7
        }
      },
      '35': {
        start: {
          line: 55,
          column: 10
        },
        end: {
          line: 55,
          column: 52
        }
      },
      '36': {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 56,
          column: 62
        }
      },
      '37': {
        start: {
          line: 57,
          column: 10
        },
        end: {
          line: 57,
          column: 16
        }
      },
      '38': {
        start: {
          line: 60,
          column: 10
        },
        end: {
          line: 60,
          column: 54
        }
      },
      '39': {
        start: {
          line: 61,
          column: 10
        },
        end: {
          line: 61,
          column: 64
        }
      },
      '40': {
        start: {
          line: 63,
          column: 10
        },
        end: {
          line: 63,
          column: 16
        }
      },
      '41': {
        start: {
          line: 66,
          column: 10
        },
        end: {
          line: 66,
          column: 53
        }
      },
      '42': {
        start: {
          line: 67,
          column: 10
        },
        end: {
          line: 67,
          column: 63
        }
      },
      '43': {
        start: {
          line: 68,
          column: 10
        },
        end: {
          line: 68,
          column: 16
        }
      },
      '44': {
        start: {
          line: 71,
          column: 10
        },
        end: {
          line: 71,
          column: 52
        }
      },
      '45': {
        start: {
          line: 72,
          column: 10
        },
        end: {
          line: 72,
          column: 62
        }
      },
      '46': {
        start: {
          line: 73,
          column: 10
        },
        end: {
          line: 73,
          column: 16
        }
      },
      '47': {
        start: {
          line: 76,
          column: 10
        },
        end: {
          line: 76,
          column: 53
        }
      },
      '48': {
        start: {
          line: 77,
          column: 10
        },
        end: {
          line: 77,
          column: 63
        }
      },
      '49': {
        start: {
          line: 78,
          column: 10
        },
        end: {
          line: 78,
          column: 16
        }
      },
      '50': {
        start: {
          line: 80,
          column: 10
        },
        end: {
          line: 80,
          column: 53
        }
      },
      '51': {
        start: {
          line: 81,
          column: 10
        },
        end: {
          line: 81,
          column: 63
        }
      },
      '52': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 43
        }
      },
      '53': {
        start: {
          line: 87,
          column: 20
        },
        end: {
          line: 87,
          column: 22
        }
      },
      '54': {
        start: {
          line: 88,
          column: 23
        },
        end: {
          line: 88,
          column: 94
        }
      },
      '55': {
        start: {
          line: 89,
          column: 21
        },
        end: {
          line: 89,
          column: 57
        }
      },
      '56': {
        start: {
          line: 90,
          column: 20
        },
        end: {
          line: 90,
          column: 80
        }
      },
      '57': {
        start: {
          line: 91,
          column: 18
        },
        end: {
          line: 91,
          column: 19
        }
      },
      '58': {
        start: {
          line: 92,
          column: 24
        },
        end: {
          line: 92,
          column: 25
        }
      },
      '59': {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 124,
          column: 7
        }
      },
      '60': {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 97,
          column: 9
        }
      },
      '61': {
        start: {
          line: 95,
          column: 10
        },
        end: {
          line: 95,
          column: 20
        }
      },
      '62': {
        start: {
          line: 96,
          column: 10
        },
        end: {
          line: 96,
          column: 44
        }
      },
      '63': {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 16
        }
      },
      '64': {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 101,
          column: 9
        }
      },
      '65': {
        start: {
          line: 100,
          column: 10
        },
        end: {
          line: 100,
          column: 16
        }
      },
      '66': {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 102,
          column: 39
        }
      },
      '67': {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 103,
          column: 53
        }
      },
      '68': {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 104,
          column: 23
        }
      },
      '69': {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 122,
          column: 9
        }
      },
      '70': {
        start: {
          line: 106,
          column: 25
        },
        end: {
          line: 106,
          column: 62
        }
      },
      '71': {
        start: {
          line: 107,
          column: 10
        },
        end: {
          line: 109,
          column: 11
        }
      },
      '72': {
        start: {
          line: 108,
          column: 12
        },
        end: {
          line: 108,
          column: 72
        }
      },
      '73': {
        start: {
          line: 110,
          column: 10
        },
        end: {
          line: 112,
          column: 11
        }
      },
      '74': {
        start: {
          line: 111,
          column: 12
        },
        end: {
          line: 111,
          column: 54
        }
      },
      '75': {
        start: {
          line: 113,
          column: 10
        },
        end: {
          line: 113,
          column: 73
        }
      },
      '76': {
        start: {
          line: 114,
          column: 10
        },
        end: {
          line: 121,
          column: 13
        }
      },
      '77': {
        start: {
          line: 123,
          column: 8
        },
        end: {
          line: 123,
          column: 57
        }
      },
      '78': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 125,
          column: 19
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 49
          },
          end: {
            line: 2,
            column: 50
          }
        },
        loc: {
          start: {
            line: 2,
            column: 80
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 2
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 7,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 7,
            column: 7
          }
        }, {
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 7,
            column: 7
          }
        }],
        line: 5
      },
      '1': {
        loc: {
          start: {
            line: 8,
            column: 20
          },
          end: {
            line: 8,
            column: 35
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 8,
            column: 20
          },
          end: {
            line: 8,
            column: 27
          }
        }, {
          start: {
            line: 8,
            column: 31
          },
          end: {
            line: 8,
            column: 35
          }
        }],
        line: 8
      },
      '2': {
        loc: {
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        }, {
          start: {
            line: 11,
            column: 6
          },
          end: {
            line: 13,
            column: 7
          }
        }],
        line: 11
      },
      '3': {
        loc: {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 16,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 16,
            column: 7
          }
        }, {
          start: {
            line: 14,
            column: 6
          },
          end: {
            line: 16,
            column: 7
          }
        }],
        line: 14
      },
      '4': {
        loc: {
          start: {
            line: 29,
            column: 21
          },
          end: {
            line: 29,
            column: 38
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 29,
            column: 21
          },
          end: {
            line: 29,
            column: 29
          }
        }, {
          start: {
            line: 29,
            column: 33
          },
          end: {
            line: 29,
            column: 38
          }
        }],
        line: 29
      },
      '5': {
        loc: {
          start: {
            line: 30,
            column: 19
          },
          end: {
            line: 30,
            column: 36
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 30,
            column: 19
          },
          end: {
            line: 30,
            column: 27
          }
        }, {
          start: {
            line: 30,
            column: 31
          },
          end: {
            line: 30,
            column: 36
          }
        }],
        line: 30
      },
      '6': {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }, {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 46,
            column: 7
          }
        }],
        line: 41
      },
      '7': {
        loc: {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        }, {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        }],
        line: 42
      },
      '8': {
        loc: {
          start: {
            line: 45,
            column: 68
          },
          end: {
            line: 45,
            column: 92
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 45,
            column: 78
          },
          end: {
            line: 45,
            column: 83
          }
        }, {
          start: {
            line: 45,
            column: 86
          },
          end: {
            line: 45,
            column: 92
          }
        }],
        line: 45
      },
      '9': {
        loc: {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 82,
            column: 7
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 17
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 57,
            column: 16
          }
        }, {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 58,
            column: 15
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 63,
            column: 16
          }
        }, {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 64,
            column: 15
          }
        }, {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 68,
            column: 16
          }
        }, {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 15
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 73,
            column: 16
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 16
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 78,
            column: 16
          }
        }, {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 81,
            column: 63
          }
        }],
        line: 52
      },
      '10': {
        loc: {
          start: {
            line: 83,
            column: 13
          },
          end: {
            line: 83,
            column: 42
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 83,
            column: 23
          },
          end: {
            line: 83,
            column: 33
          }
        }, {
          start: {
            line: 83,
            column: 36
          },
          end: {
            line: 83,
            column: 42
          }
        }],
        line: 83
      },
      '11': {
        loc: {
          start: {
            line: 88,
            column: 24
          },
          end: {
            line: 88,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 88,
            column: 24
          },
          end: {
            line: 88,
            column: 32
          }
        }, {
          start: {
            line: 88,
            column: 36
          },
          end: {
            line: 88,
            column: 41
          }
        }],
        line: 88
      },
      '12': {
        loc: {
          start: {
            line: 88,
            column: 62
          },
          end: {
            line: 88,
            column: 79
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 88,
            column: 62
          },
          end: {
            line: 88,
            column: 70
          }
        }, {
          start: {
            line: 88,
            column: 74
          },
          end: {
            line: 88,
            column: 79
          }
        }],
        line: 88
      },
      '13': {
        loc: {
          start: {
            line: 90,
            column: 35
          },
          end: {
            line: 90,
            column: 52
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 90,
            column: 35
          },
          end: {
            line: 90,
            column: 43
          }
        }, {
          start: {
            line: 90,
            column: 47
          },
          end: {
            line: 90,
            column: 52
          }
        }],
        line: 90
      },
      '14': {
        loc: {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        }, {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        }],
        line: 94
      },
      '15': {
        loc: {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        }, {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        }],
        line: 99
      },
      '16': {
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 122,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 122,
            column: 9
          }
        }, {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 122,
            column: 9
          }
        }],
        line: 105
      },
      '17': {
        loc: {
          start: {
            line: 106,
            column: 35
          },
          end: {
            line: 106,
            column: 53
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 106,
            column: 45
          },
          end: {
            line: 106,
            column: 47
          }
        }, {
          start: {
            line: 106,
            column: 50
          },
          end: {
            line: 106,
            column: 53
          }
        }],
        line: 106
      },
      '18': {
        loc: {
          start: {
            line: 107,
            column: 10
          },
          end: {
            line: 109,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 107,
            column: 10
          },
          end: {
            line: 109,
            column: 11
          }
        }, {
          start: {
            line: 107,
            column: 10
          },
          end: {
            line: 109,
            column: 11
          }
        }],
        line: 107
      },
      '19': {
        loc: {
          start: {
            line: 108,
            column: 46
          },
          end: {
            line: 108,
            column: 70
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 108,
            column: 56
          },
          end: {
            line: 108,
            column: 61
          }
        }, {
          start: {
            line: 108,
            column: 64
          },
          end: {
            line: 108,
            column: 70
          }
        }],
        line: 108
      },
      '20': {
        loc: {
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 112,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 112,
            column: 11
          }
        }, {
          start: {
            line: 110,
            column: 10
          },
          end: {
            line: 112,
            column: 11
          }
        }],
        line: 110
      },
      '21': {
        loc: {
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 72
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 113,
            column: 49
          },
          end: {
            line: 113,
            column: 66
          }
        }, {
          start: {
            line: 113,
            column: 70
          },
          end: {
            line: 113,
            column: 72
          }
        }],
        line: 113
      },
      '22': {
        loc: {
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 45
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 29
          }
        }, {
          start: {
            line: 113,
            column: 33
          },
          end: {
            line: 113,
            column: 45
          }
        }],
        line: 113
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0
    },
    f: {
      '0': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2azlcqa2zm.s[0]++;
angular.module('deltadate', []).factory('$deltadate', ['$translate', '$filter', function ($translate, $filter) {
  cov_2azlcqa2zm.f[0]++;
  cov_2azlcqa2zm.s[1]++;

  return {
    format: function format(date, _format) {
      cov_2azlcqa2zm.s[2]++;

      if (angular.isString(date)) {
        cov_2azlcqa2zm.b[0][0]++;
        cov_2azlcqa2zm.s[3]++;

        return date;
      } else {
        cov_2azlcqa2zm.b[0][1]++;
      }
      var value = (cov_2azlcqa2zm.s[4]++, (cov_2azlcqa2zm.b[1][0]++, date._d) || (cov_2azlcqa2zm.b[1][1]++, date));
      var mm = (cov_2azlcqa2zm.s[5]++, value.getMonth() + 1); // getMonth() is zero-based
      var dd = (cov_2azlcqa2zm.s[6]++, value.getDate());
      cov_2azlcqa2zm.s[7]++;
      if (dd < 10) {
        cov_2azlcqa2zm.b[2][0]++;
        cov_2azlcqa2zm.s[8]++;

        dd = '0' + dd;
      } else {
        cov_2azlcqa2zm.b[2][1]++;
      }
      cov_2azlcqa2zm.s[9]++;
      if (mm < 10) {
        cov_2azlcqa2zm.b[3][0]++;
        cov_2azlcqa2zm.s[10]++;

        mm = '0' + mm;
      } else {
        cov_2azlcqa2zm.b[3][1]++;
      }
      var year = (cov_2azlcqa2zm.s[11]++, value.getFullYear());
      var result = (cov_2azlcqa2zm.s[12]++, _format);
      cov_2azlcqa2zm.s[13]++;
      result = result.replace('yyyy', year);
      cov_2azlcqa2zm.s[14]++;
      result = result.replace('YYYY', year);
      cov_2azlcqa2zm.s[15]++;
      result = result.replace('mm', mm);
      cov_2azlcqa2zm.s[16]++;
      result = result.replace('MM', mm);
      cov_2azlcqa2zm.s[17]++;
      result = result.replace('dd', dd);
      cov_2azlcqa2zm.s[18]++;
      result = result.replace('DD', dd);
      cov_2azlcqa2zm.s[19]++;
      return result;
    },
    getYearBetween: function getYearBetween(dateD, dateF) {
      var result = (cov_2azlcqa2zm.s[20]++, []);
      var begin = (cov_2azlcqa2zm.s[21]++, ((cov_2azlcqa2zm.b[4][0]++, dateD._d) || (cov_2azlcqa2zm.b[4][1]++, dateD)).getFullYear());
      var end = (cov_2azlcqa2zm.s[22]++, ((cov_2azlcqa2zm.b[5][0]++, dateF._d) || (cov_2azlcqa2zm.b[5][1]++, dateF)).getFullYear());
      var length = (cov_2azlcqa2zm.s[23]++, end - begin);
      cov_2azlcqa2zm.s[24]++;
      for (var i = 0; i <= length; i++) {
        cov_2azlcqa2zm.s[25]++;

        result.push({
          name: (begin + i).toString(),
          id: (begin + i).toString()
        });
      }
      cov_2azlcqa2zm.s[26]++;
      return result;
    },
    getLabelPerioddepth: function getLabelPerioddepth(num, per, isShort) {
      cov_2azlcqa2zm.s[27]++;

      if (0 - -per === 12) {
        cov_2azlcqa2zm.b[6][0]++;
        cov_2azlcqa2zm.s[28]++;

        if (num < 10) {
          cov_2azlcqa2zm.b[7][0]++;
          cov_2azlcqa2zm.s[29]++;

          num = '0' + num;
        } else {
          cov_2azlcqa2zm.b[7][1]++;
        }
        cov_2azlcqa2zm.s[30]++;
        return $filter('date')(Date.newDate('1989-' + num + '-02'), isShort ? (cov_2azlcqa2zm.b[8][0]++, 'MMM') : (cov_2azlcqa2zm.b[8][1]++, 'MMMM'));
      } else {
        cov_2azlcqa2zm.b[6][1]++;
      }
      cov_2azlcqa2zm.s[31]++;
      return this.getLabelPeriod(per, isShort) + ' ' + num;
    },
    getLabelPeriod: function getLabelPeriod(per, isShort) {
      var labelP = (cov_2azlcqa2zm.s[32]++, '');
      var labelShort = (cov_2azlcqa2zm.s[33]++, '');
      cov_2azlcqa2zm.s[34]++;
      switch (per) {
        case '2':
          cov_2azlcqa2zm.b[9][0]++;

        case 2:
          cov_2azlcqa2zm.b[9][1]++;
          cov_2azlcqa2zm.s[35]++;

          labelP = $translate.instant('COMMON.SEM');
          cov_2azlcqa2zm.s[36]++;
          labelShort = $translate.instant('COMMON.SEM_SHORT');
          cov_2azlcqa2zm.s[37]++;
          break;
        case 3:
          cov_2azlcqa2zm.b[9][2]++;

        case '3':
          cov_2azlcqa2zm.b[9][3]++;
          cov_2azlcqa2zm.s[38]++;

          labelP = $translate.instant('COMMON.QUATR');
          cov_2azlcqa2zm.s[39]++;
          labelShort = $translate.instant('COMMON.QUATR_SHORT');

          cov_2azlcqa2zm.s[40]++;
          break;
        case 4:
          cov_2azlcqa2zm.b[9][4]++;

        case '4':
          cov_2azlcqa2zm.b[9][5]++;
          cov_2azlcqa2zm.s[41]++;

          labelP = $translate.instant('COMMON.TRIM');
          cov_2azlcqa2zm.s[42]++;
          labelShort = $translate.instant('COMMON.TRIM_SHORT');
          cov_2azlcqa2zm.s[43]++;
          break;
        case 6:
          cov_2azlcqa2zm.b[9][6]++;

        case '6':
          cov_2azlcqa2zm.b[9][7]++;
          cov_2azlcqa2zm.s[44]++;

          labelP = $translate.instant('COMMON.BIM');
          cov_2azlcqa2zm.s[45]++;
          labelShort = $translate.instant('COMMON.BIM_SHORT');
          cov_2azlcqa2zm.s[46]++;
          break;
        case 12:
          cov_2azlcqa2zm.b[9][8]++;

        case '12':
          cov_2azlcqa2zm.b[9][9]++;
          cov_2azlcqa2zm.s[47]++;

          labelP = $translate.instant('COMMON.MOIS');
          cov_2azlcqa2zm.s[48]++;
          labelShort = $translate.instant('COMMON.MOIS_SHORT');
          cov_2azlcqa2zm.s[49]++;
          break;
        default:
          cov_2azlcqa2zm.b[9][10]++;
          cov_2azlcqa2zm.s[50]++;

          labelP = $translate.instant('COMMON.YEAR');
          cov_2azlcqa2zm.s[51]++;
          labelShort = $translate.instant('COMMON.YEAR_SHORT');
      }
      cov_2azlcqa2zm.s[52]++;
      return isShort ? (cov_2azlcqa2zm.b[10][0]++, labelShort) : (cov_2azlcqa2zm.b[10][1]++, labelP);
    },
    getPeriods: function getPeriods(dateD, dateF, period) {
      var resul = (cov_2azlcqa2zm.s[53]++, []);
      var isShort = (cov_2azlcqa2zm.s[54]++, ((cov_2azlcqa2zm.b[11][0]++, dateD._d) || (cov_2azlcqa2zm.b[11][1]++, dateD)).getFullYear() !== ((cov_2azlcqa2zm.b[12][0]++, dateF._d) || (cov_2azlcqa2zm.b[12][1]++, dateF)).getFullYear());
      var labelP = (cov_2azlcqa2zm.s[55]++, this.getLabelPeriod(period, isShort));
      var begin = (cov_2azlcqa2zm.s[56]++, Date.newDate(((cov_2azlcqa2zm.b[13][0]++, dateD._d) || (cov_2azlcqa2zm.b[13][1]++, dateD)).getFullYear() + '-01-01'));
      var index = (cov_2azlcqa2zm.s[57]++, 0);
      var currentYear = (cov_2azlcqa2zm.s[58]++, 0);
      cov_2azlcqa2zm.s[59]++;
      while (true) {
        cov_2azlcqa2zm.s[60]++;

        if (currentYear !== begin.getFullYear()) {
          cov_2azlcqa2zm.b[14][0]++;
          cov_2azlcqa2zm.s[61]++;

          index = 0;
          cov_2azlcqa2zm.s[62]++;
          currentYear = begin.getFullYear();
        } else {
          cov_2azlcqa2zm.b[14][1]++;
        }
        cov_2azlcqa2zm.s[63]++;
        index++;
        cov_2azlcqa2zm.s[64]++;
        if (begin > dateF) {
          cov_2azlcqa2zm.b[15][0]++;
          cov_2azlcqa2zm.s[65]++;

          break;
        } else {
          cov_2azlcqa2zm.b[15][1]++;
        }
        var end = (cov_2azlcqa2zm.s[66]++, angular.copy(begin));
        cov_2azlcqa2zm.s[67]++;
        end.setMonth(end.getMonth() + 12 / period);
        cov_2azlcqa2zm.s[68]++;
        end.setDate(0);
        cov_2azlcqa2zm.s[69]++;
        if (end >= dateD) {
          cov_2azlcqa2zm.b[16][0]++;

          var reslabel = (cov_2azlcqa2zm.s[70]++, labelP + (isShort ? (cov_2azlcqa2zm.b[17][0]++, '') : (cov_2azlcqa2zm.b[17][1]++, ' ')) + index);
          cov_2azlcqa2zm.s[71]++;
          if (period === 12) {
            cov_2azlcqa2zm.b[18][0]++;
            cov_2azlcqa2zm.s[72]++;

            reslabel = $filter('date')(begin, isShort ? (cov_2azlcqa2zm.b[19][0]++, 'MMM') : (cov_2azlcqa2zm.b[19][1]++, 'MMMM'));
          } else {
            cov_2azlcqa2zm.b[18][1]++;
          }
          cov_2azlcqa2zm.s[73]++;
          if (period === 1) {
            cov_2azlcqa2zm.b[20][0]++;
            cov_2azlcqa2zm.s[74]++;

            reslabel = $filter('date')(begin, 'yyyy');
          } else {
            cov_2azlcqa2zm.b[20][1]++;
          }
          cov_2azlcqa2zm.s[75]++;
          reslabel += (cov_2azlcqa2zm.b[22][0]++, isShort) && (cov_2azlcqa2zm.b[22][1]++, period !== 1) ? (cov_2azlcqa2zm.b[21][0]++, ' ' + currentYear) : (cov_2azlcqa2zm.b[21][1]++, '');
          cov_2azlcqa2zm.s[76]++;
          resul.push({
            year: currentYear,
            label: reslabel,
            begin: Date.newDate(Math.max(begin, dateD)),
            end: Date.newDate(Math.min(end, dateF)),
            datet: angular.copy(begin),
            index: index
          });
        } else {
          cov_2azlcqa2zm.b[16][1]++;
        }
        cov_2azlcqa2zm.s[77]++;
        begin.setMonth(begin.getMonth() + 12 / period);
      }
      cov_2azlcqa2zm.s[78]++;
      return resul;
    }
  };
}]);